import React, { useState, useEffect } from "react";
import styled from "styled-components";

const Container = styled.div`
  display: inline-block;
`;

const Input = styled.input`
  font-size: 2rem;
  border: none;
  border-bottom: 1px solid #ff734f;
  outline: none;
  padding: 0.5rem;
  color: #666;
  min-width: 400px;
  font-size: 28px;

  &::placeholder {
    color: #999;
  }
`;

interface TypewriterInputProps {
  value: string;
  onChange: (value: string) => void;
  examples: string[];
}

const TypewriterInput: React.FC<TypewriterInputProps> = ({
  value,
  onChange,
  examples,
}) => {
  const [placeholder, setPlaceholder] = useState("");
  const [exampleIndex, setExampleIndex] = useState(0);
  const [isDeleting, setIsDeleting] = useState(false);
  const [isFocused, setIsFocused] = useState(false);

  useEffect(() => {
    if (isFocused) return;

    const currentExample = examples[exampleIndex];
    const typeSpeed = 100;
    const deleteSpeed = 50;
    const pauseDuration = 2000;

    if (isDeleting) {
      if (placeholder === "") {
        setIsDeleting(false);
        setExampleIndex((prev) => (prev + 1) % examples.length);
        return;
      }

      const timer = setTimeout(() => {
        setPlaceholder((prev) => prev.slice(0, -1));
      }, deleteSpeed);
      return () => clearTimeout(timer);
    }

    if (placeholder === currentExample) {
      const timer = setTimeout(() => {
        setIsDeleting(true);
      }, pauseDuration);
      return () => clearTimeout(timer);
    }

    const timer = setTimeout(() => {
      setPlaceholder(currentExample.slice(0, placeholder.length + 1));
    }, typeSpeed);

    return () => clearTimeout(timer);
  }, [placeholder, isDeleting, exampleIndex, examples, isFocused]);

  return (
    <Container>
      <Input
        type="text"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        onFocus={() => setIsFocused(true)}
        placeholder={isFocused ? "Écrivez votre sujet..." : placeholder}
      />
    </Container>
  );
};

export default TypewriterInput;
